function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrimecoin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.8 3.148c.012 3.403.009 3.317.16 3.97.403 1.726 1.638 2.866 3.52 3.245.313.059.73.11.961.11h.164v.93h-1.64v1.202h1.64V14h2.707v-1.395h1.723v-1.203H8.312v-.898l.215-.016c.758-.058 1.196-.136 1.723-.312 1.254-.418 2.168-1.262 2.625-2.414.105-.27.191-.574.258-.942.05-.289.055-.418.066-3.562L13.211 0h-2.68l-.011 3.164c-.008 2.797-.016 3.188-.055 3.356-.117.511-.277.824-.594 1.14-.2.2-.277.254-.492.36a2 2 0 0 1-.824.23l-.242.016V0h-2.68v8.266L5.43 8.25a2.6 2.6 0 0 1-.809-.238 2.02 2.02 0 0 1-.988-1.14c-.149-.434-.14-.259-.153-3.696L3.47 0H.789Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "currentColor",
    fillOpacity: 1
  }
}));
export default SvgPrimecoin;